import { useState, useMemo, useEffect, useRef } from "react";
import { Representee } from "api/common/useGetContactInfo";
import { ComboBox, Option } from "components/ComboBox/ComboBox";
import { useModifiedTranslation } from "hooks/useModifiedTranslation";

interface ImpersonationSelectProps {
    representees: Representee[];
    selected: Representee | undefined;
    onSelect: (representee: Representee) => void;
}

export const ImpersonationSelect = ({
    representees,
    selected,
    onSelect,
}: ImpersonationSelectProps) => {
    const [searchQuery, setSearchQuery] = useState("");
    const isMountedRef = useRef(true);
    const { t } = useModifiedTranslation();

    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);

        const safeSetSearchQuery = (query: string) => {
        if (isMountedRef.current) {
            setSearchQuery(query);
        }
    };

    const options = useMemo(
        () => representees.map((r) => ({ id: r.id, label: r.name })),
        [representees]
    );


    const selectedOption = selected
        ? { id: selected.id, label: selected.name }
        : undefined;

    const handleChange = (option: Option) => {
        const representee = representees.find((r) => r.id === option.id);
        if (representee) onSelect(representee);
    };

    return (
        <div className="min-w-[350px]">
            <ComboBox
                value={selectedOption}
                onChange={handleChange}
                options={options}
                searchQuery={searchQuery}
                onSearchQueryChange={safeSetSearchQuery}
                label={t("userMenu.switchUserLabel")}
            />
        </div>
    );
};
